import React from 'react';

import Metadata from '@pray/shared/components/Metadata';

import { ChartPie, UsersWm, Social, Sparkle } from 'components/pages/public/components/icons/benefits';
import { CDH } from 'components/pages/public/components/icons/features';
import { PRODUCT_LABELS, Products } from 'components/pages/public/types/products';
import { VIEW_EVENT_NAMES } from 'constants.js';

import { Header } from '../../../../components/Header/Header';
import ProductPageLayout from '../../layout/ProductPageLayout';

const MinistryInsightsPage: React.FC = () => {
  return (
    <div data-viewname={VIEW_EVENT_NAMES.PRODUCTS.MINISTRY_INSIGHTS}>
      <Metadata
        title={`${PRODUCT_LABELS[Products.MINISTRY_INSIGHTS]}: Grow with AI Data Analytics | ${
          PRODUCT_LABELS[Products.PRAYSTUDIO]
        }`}
        description={`Unlock growth with ${PRODUCT_LABELS[Products.MINISTRY_INSIGHTS]}. Use ${
          PRODUCT_LABELS[Products.PRAYSTUDIO]
        }'s AI analytics to understand your audience & thrive!`}
      />
      <Header />
      <ProductPageLayout
        // Hero section
        tag={PRODUCT_LABELS[Products.MINISTRY_INSIGHTS]}
        icon={<CDH />}
        title="Unify Your Data and Transform Your Ministry"
        description="Gain insights, identify personas, and unify data across various social channels and sources to connect with your audience like never before."
        ctaText="GET STARTED"
        heroMedia={{
          type: 'image',
          src: 'https://d339bgihw9yfmi.cloudfront.net/web/images/ministry-insights-hero.png',
        }}
        // Benefits section
        benefitsSectionTitle={`Why ${PRODUCT_LABELS[Products.MINISTRY_INSIGHTS]}?`}
        benefits={[
          {
            icon: <ChartPie />,
            title: 'Know What Resonates',
            description: 'Track which sermons engage your audience most with powerful analytics.',
            linkText: 'LEARN MORE',
          },
          {
            icon: <UsersWm />,
            title: 'Reach the Right People',
            description: 'Discover deeply engaged listeners and unlock new audience segments.',
            linkText: 'LEARN MORE',
          },
          {
            icon: <Social />,
            title: 'Simplify Social Media',
            description: 'Manage all platforms in one place and amplify your digital outreach.',
            linkText: 'LEARN MORE',
          },
          {
            icon: <Sparkle />,
            title: 'Grow with Insight',
            description: 'Make informed decisions with AI-powered tools tailored for your mission.',
            linkText: 'LEARN MORE',
          },
        ]}
        howItWorksSectionTitle="Powerful Features Crafted for Your Ministry"
        steps={[
          {
            tag: 'ANALYTICS DASHBOARDS',
            title: 'Know What Resonates',
            description:
              'Gain a clear view of your audience with intuitive dashboards. Discover which sermons are most popular, track shares, and uncover listening and viewing trends—giving you the insights you need to connect more deeply.',
            buttonText: 'GET STARTED',
            imageSrc: 'https://d339bgihw9yfmi.cloudfront.net/web/images/ministry-insights-benefit-step-1.png',
            imageAlt: 'See the Impact of Every Message',
          },
          {
            tag: 'PERIODIC TABLE OF PERSONAS',
            title: 'Reach the Right People',
            description:
              'Turn raw data into a roadmap for growth. Identify who’s engaging with your ministry, pinpoint unreached audiences, and craft strategies that work. With machine learning at your fingertips, your digital outreach becomes smarter and more effective.',
            buttonText: 'GET STARTED',
            imageSrc: 'https://d339bgihw9yfmi.cloudfront.net/web/images/ministry-insights-benefit-step-2.png',
            imageAlt: 'Simplify and Magnify',
          },
          {
            tag: 'SOCIAL INTEGRATION',
            title: 'Simplify Social Media',
            description: `Bring your social media efforts together in one place. Leverage ${
              PRODUCT_LABELS[Products.PRAYSTUDIO]
            }’s Advanced Data Architecture to extract actionable insights from your online presence, driving real, measurable impact for your ministry.`,
            buttonText: 'GET STARTED',
            imageSrc: 'https://d339bgihw9yfmi.cloudfront.net/web/images/ministry-insights-benefit-step-3.png',
            imageAlt: 'Fast Turnaround',
          },
        ]}
        // Solution cards section (using placeholders as before)
        solutionsSectionTitle="All-in-one Solution"
      />
    </div>
  );
};

export default MinistryInsightsPage;
